.svg {
  fill: #4C4C4C;
}

